import * as React from 'react';

// Components
import { InputUsername, InputPhone } from '@shopee-user/input';

// Utils
import { useTranslation } from '@shopee-user/platform';
import { isFeatureEnabled } from '@shopee-user/business-customization-logic';

// Constants
import { Feature } from '@shopee-user/feature-toggle';

// Types
import { InputProps } from '@shopee-user/input';

export const MAX_SIGNUP_KEY_LENGTH = 128;

function SignupInputAuthKey(props: InputProps) {
  const I18n = useTranslation();
  const isAllowSignupByEmail = isFeatureEnabled(Feature.SignupByOtpAllowEmail);
  return isAllowSignupByEmail ? (
    <InputUsername
      type="text"
      placeholder={I18n.t('label_auth_phone_number_or_email')}
      showError
      showErrorOutline
      autoFocus
      maxLength={MAX_SIGNUP_KEY_LENGTH}
      autoComplete="on"
      {...props}
    />
  ) : (
    <InputPhone
      {...props}
      placeholder={I18n.t('label_auth_phone_number')}
      showErrorOutline
      showError
      autoFocus
    />
  );
}

export default SignupInputAuthKey;
